export default function DashboardVerifikatorButawarnaPage() {
  return <div>DashboardVerifikatorButawarnaPage</div>;
}
